const creditCardConfig = require('./creditcardutils-config');
const jobUtilConfig = require('./jobutil-config');
const lobIconUtilConfig = require('./lobiconutil-config');
const productMediaMapUtilConfig = require('./productmediamaputil-config');
const extractAddressUtilConfig = require('./extractaddressutil-config');
const dateUtilConfig = require('./dateutil-config');

module.exports = {
    'creditCard': creditCardConfig,
    'jobUtil': jobUtilConfig,
    'lobIconUtil': lobIconUtilConfig,
    'productMediaMapUtil': productMediaMapUtilConfig,
    'extractAddress': extractAddressUtilConfig,
    'customerDateUtil': dateUtilConfig
}